
enum Direction {
  Left,
  Right,
  Up,
  Down
}

export {
  Direction
}